module.exports = __webpack_public_path__ + "static/media/rectangular2.8d1ead0b.png";